// extracted by mini-css-extract-plugin
module.exports = {"Container":"ProductList_Container__1lEGm","Title":"ProductList_Title__KKBdB","TotalAmount":"ProductList_TotalAmount__m-GvM","ProductList":"ProductList_ProductList__3YuzN"};